import type { ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";

import { z } from "zod";

export const backofficeFindSiteLastButtonEventResponseSchema = z
  .object({
    dateArrival: z.coerce.date(),
    dateMombox: z.coerce.date(),
    modulatorHwId: z.number().transform((s) => s as ModulatorHwId),
    momboxHwId: z.number().transform((s) => s as PilotHwId),
  })
  .array();

export type BackofficeFindSiteLastButtonEventResponse = z.infer<typeof backofficeFindSiteLastButtonEventResponseSchema>;
